import {
    HTMLAttributes,
    ReactElement
} from "react";
import { Calendar } from "../../assets";
import { getPersianDate, getPersianYear } from "../../core/utils";
interface Props extends HTMLAttributes<HTMLElement> {
    myStyle?: string;

}
export function CurrentDate({ myStyle}: Props): ReactElement {
    return (
        <div className={`${myStyle && myStyle } current-date`}>
            <img src={Calendar} alt="هامرز" className="ms-1"/>
            <span className="date">
              {getPersianDate()} {" "} 
            </span>
            {/* <div className="vl"></div> */}
            <span className="date date-light me-1">
             {getPersianYear()}
            </span>
          </div>
    )
}
export default CurrentDate;
